import { Controller } from "@hotwired/stimulus"

// Controlador Stimulus para seções expansíveis em páginas de detalhes (show)
// 
// Uso básico:
// 1. Adicione o atributo data-controller="expandable-sections" no elemento container
// 2. Use os seguintes data attributes:
//    - data-expandable-sections-target="section" em cada seção
//    - data-section-id="unique-id" em cada seção (obrigatório)
//    - data-action="click->expandable-sections#toggle" no cabeçalho de cada seção
//    - data-expandable-sections-target="toggleIcon" no botão de expandir/recolher todas as seções (opcional)
//
// Exemplo de estrutura HTML:
/*
<div data-controller="expandable-sections">
  <div class="actions">
    <div data-action="click->expandable-sections#toggleAll" 
         data-expandable-sections-target="toggleIcon" 
         title="Expandir/Colapsar Todas as Seções">
      <i class="zmdi zmdi-unfold-less"></i>
    </div>
  </div>

  <div data-expandable-sections-target="section" data-section-id="basic-info">
    <div class="card-header" data-action="click->expandable-sections#toggle">
      <span class="show-section-arrow">
        <i class="zmdi zmdi-chevron-down nav-arrow"></i>
      </span>
      <h4>Seção Básica</h4>
    </div>
    <div class="card-body show-section-body">
      <!-- Conteúdo da seção -->
    </div>
  </div>

  <div data-expandable-sections-target="section" data-section-id="details-info">
    <div class="card-header" data-action="click->expandable-sections#toggle">
      <span class="show-section-arrow">
        <i class="zmdi zmdi-chevron-down nav-arrow"></i>
      </span>
      <h4>Seção de Detalhes</h4>
    </div>
    <div class="card-body show-section-body show-section-collapsed">
      <!-- Conteúdo da seção -->
    </div>
  </div>
</div>
*/
export default class extends Controller {
  static targets = ["section", "arrow", "toggleIcon"]
  
  connect() {
    // Percorre todas as seções
    this.sectionTargets.forEach((section, index) => {
      const body = section.querySelector('.show-section-body')
      const arrow = section.querySelector('.nav-arrow')
      
      if (!body || !arrow) return

      const isFiltersCard = section.hasAttribute('data-filters-card')
      const filtersApplied = section.getAttribute('data-filters-applied') === 'true'
      
      if (section.closest('form') && !isFiltersCard) {
        // No formulário (exceto filtros), todos os cards começam maximizados
        body.classList.remove('show-section-collapsed')
        arrow.style.transform = 'rotate(0deg)'
        arrow.classList.add('section-open')
      } else if (isFiltersCard) {
        // Componente de filtros: só começa minimizado se NÃO houver filtros aplicados
        if (!filtersApplied) {
          body.classList.add('show-section-collapsed')
          arrow.style.transform = 'rotate(180deg)'
          arrow.classList.remove('section-open')
        } else {
          body.classList.remove('show-section-collapsed')
          arrow.style.transform = 'rotate(0deg)'
          arrow.classList.add('section-open')
        }
      } else {
        // Na página de show, primeira seção maximizada, outras minimizadas
        if (index === 0) {
          body.classList.remove('show-section-collapsed')
          arrow.style.transform = 'rotate(180deg)'
          arrow.classList.remove('section-open')
        } else {
          body.classList.add('show-section-collapsed')
          arrow.style.transform = 'rotate(180deg)'
          arrow.classList.remove('section-open')
        }
      }
    })
  }

  toggle(event) {
    const sectionElement = event.currentTarget.closest('[data-expandable-sections-target="section"]')
    if (!sectionElement) return

    const body = sectionElement.querySelector('.show-section-body')
    const arrow = sectionElement.querySelector('.nav-arrow')
    
    if (!body || !arrow) return
    
    // Permite minimizar/maximizar qualquer seção
    body.classList.toggle('show-section-collapsed')
    
    if (body.classList.contains('show-section-collapsed')) {
      arrow.style.transform = 'rotate(180deg)' // Minimizada, seta para baixo
      arrow.classList.remove('section-open')
    } else {
      arrow.style.transform = 'rotate(0deg)' // Expandida, seta para cima
      arrow.classList.add('section-open')
    }
  }

  toggleAll() {
    const sectionsToToggle = this.sectionTargets.slice(1)
    const allExpanded = sectionsToToggle.every(section => 
      section.querySelector('.show-section-body').classList.contains('show-section-collapsed')
    )
    
    sectionsToToggle.forEach(section => {
      const body = section.querySelector('.show-section-body')
      const arrow = section.querySelector('.nav-arrow')
      
      if (body && arrow) {
        if (allExpanded) {
          body.classList.remove('show-section-collapsed')
          arrow.style.transform = 'rotate(0deg)' // Expandida, seta para cima
          arrow.classList.add('section-open')
        } else {
          body.classList.add('show-section-collapsed')
          arrow.style.transform = 'rotate(180deg)' // Minimizada, seta para baixo
          arrow.classList.remove('section-open')
        }
      }
    })
    
    // Atualiza o ícone global
    if (this.hasToggleIconTarget) {
      const iconElement = this.toggleIconTarget.querySelector('i')
      iconElement.className = allExpanded ? 'zmdi zmdi-unfold-more' : 'zmdi zmdi-unfold-less'
    }
  }
} 